'use strict';

export default function f($location, social, userModel) {
  'ngInject';

  this.constructUrl = (userId) => {
    return `${$location.protocol()}://${$location.host()}/locals/${userId}`;
  };

  this.facebook = () => {
    social.fetchScripts('fb').then(() => {
      social.getSocialNetwork('fb').share(this.url);
    });
  };

  this.getText = (userId, name) => {
    var text = '';
    if (userId === userModel.item.id) {
      text = 'Check out my profile on Showaround! Discover cities with locals.';
    } else {
      text = `Check out ${name}'s profile on Showaround! Discover cities with locals.`;
    }

    return text;
  };

  return {
    share: (userId) => {
      this.url = this.constructUrl(userId);
      return (network) => {
        return this[network]();
      };
    },

    getShareUrl: () => {
      return this.constructUrl();
    },

    twitterURL: (userId, name) => {
      const text = this.getText(userId, name);
      const url = this.constructUrl(userId);
      const hashtags = 'Showaround';
      const tweetUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}
&hashtags=${hashtags}`;
      return tweetUrl;
    },

    linkedInURL: (userId, name) => {
      const title = userId === userModel.item.id ? 'I\'m on Showaround' :
        `${name}'s Showaround profile`;
      const url = this.constructUrl(userId);
      const summary = this.getText(userId, name);
      const linkedInURL = `https://www.linkedin.com/shareArticle?mini=true&url=
${url}&title=${title}&summary=${summary}`;
      return linkedInURL;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/social_share.js